import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
    devices: [],
    selectedDevice: null,
    packets: [],
    listLoading: false,
    detailsLoading: false,
    listError: '',
    detailsError: '',
    message: ''
};

const slice = createSlice({
    name: 'maps',
    initialState,
    reducers: {
        startMapData(state) {
            state.listLoading = true;
            state.listError = '';
        },
        setMapData(state, action) {
            state.devices = action.payload;
        },
        startMapPacketHistory(state) {
            state.detailsLoading = true;
            state.packets = [];
            state.detailsError = '';
        },
        setSelectedDevice(state, action) {
            state.selectedDevice = action.payload;
        },
        setMapPacketHistory(state, action) {
            state.packets = action.payload;
        },
        setMapListError(state, action) {
            state.listError = action.payload;
        },
        setMapDetailsError(state, action) {
            state.detailsError = action.payload;
        },
        completeMapDataFetch(state) {
            state.listLoading = false;
        },
        completeMapPacketHistoryFetch(state) {
            state.detailsLoading = false;
        }
    }
});

export const {
    startMapData,
    setMapData,
    startMapPacketHistory,
    setSelectedDevice,
    setMapPacketHistory,
    setMapListError,
    setMapDetailsError,
    completeMapDataFetch,
    completeMapPacketHistoryFetch
} = slice.actions;

export default slice.reducer;

const mapsState = (state) => state.maps;

export const mapDevicesSelector = createSelector([mapsState], (mapState) => mapState.devices);
export const selectedMapDeviceSelector = createSelector([mapsState], (mapState) => mapState.selectedDevice);
export const mapPacketsSelector = createSelector([mapsState], (mapState) => mapState.packets);
export const mapListLoadingSelector = createSelector([mapsState], (mapState) => mapState.listLoading);
export const mapDetailsLoadingSelector = createSelector([mapsState], (mapState) => mapState.detailsLoading);
export const mapListErrorSelector = createSelector([mapsState], (mapState) => mapState.listError);
export const mapDetailsErrorSelector = createSelector([mapsState], (mapState) => mapState.detailsError);
